import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import {
  Button,
  Form,
  SaveButton,
  Toolbar,
  useDataProvider,
  useGetIdentity,
  useNotify,
  useTranslate,
} from "react-admin";
import { FieldValues, SubmitHandler } from "react-hook-form";
import { extractErrorMessage } from "@/utilities/errorExtract";

type DialogConsumeVoucherProps = {
  voucherReference: string;
  productName: string;
  entityName: string;
  open: boolean;
  onClose: () => void;
};

const DialogConsumeVoucher = ({
  voucherReference,
  productName,
  entityName,
  open,
  onClose,
}: DialogConsumeVoucherProps) => {
  const translate = useTranslate();
  const notify = useNotify();
  const dp = useDataProvider();
  const { identity } = useGetIdentity();
  const pseudo = typeof identity?.pseudo === "string" ? identity.pseudo : "";

  const handleSubmit = async () => {
    try {
      await dp.claimVoucher({ code: voucherReference });
      notify("ra.gameoo.claimSuccess", {
        type: "info",
        messageArgs: { voucherReference, pseudo },
      });
      onClose();
    } catch (e) {
      notify(extractErrorMessage(e), { type: "warning" });
    }
  };

  const onSubmit: SubmitHandler<FieldValues> = () => handleSubmit();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{translate("ra.gameoo.claimVoucherTitle")}</DialogTitle>
      <Form onSubmit={onSubmit}>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            {translate("ra.gameoo.claimVoucherInstruction", {
              productName,
              entityName,
            })}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={onClose}
            label={translate("ra.gameoo.claimCancel")}
          />
          <Toolbar>
            <SaveButton
              label={translate("ra.gameoo.claimValidate")}
              alwaysEnable
            />
          </Toolbar>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default DialogConsumeVoucher;
